import React, { useEffect, useState, useRef, lazy } from 'react';
export function PricingSection() {
  const [bumps, setBumps] = useState({
    accoglienza: false,
    magicColor: false,
    agenda2030: false
  });
  const [flashKey, setFlashKey] = useState<string | null>(null);
  const flashTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Flash effect: briefly highlight the bump that was just toggled
  const handleBumpChange = (key: keyof typeof bumps, checked: boolean) => {
    setBumps(prev => ({
      ...prev,
      [key]: checked
    }));
    if (checked) {
      setFlashKey(key);
      if (flashTimeout.current) clearTimeout(flashTimeout.current);
      flashTimeout.current = setTimeout(() => setFlashKey(null), 600);
    }
  };
  useEffect(() => {
    return () => {
      if (flashTimeout.current) clearTimeout(flashTimeout.current);
    };
  }, []);
  // Checkout URL lookup based on selected bumps
  const getCheckoutUrl = () => {
    const key = `${bumps.accoglienza ? '1' : '0'}${bumps.magicColor ? '1' : '0'}${bumps.agenda2030 ? '1' : '0'}`;
    const urls: Record<string, string> = {
      '000': 'https://italia.edulabs.online/cart/43330386231414:1',
      '100': 'https://italia.edulabs.online/cart/43345489297526:1',
      '010': 'https://italia.edulabs.online/cart/43345507287158:1',
      '001': 'https://italia.edulabs.online/cart/43345509253238:1',
      '110': 'https://italia.edulabs.online/cart/43345602871414:1',
      '101': 'https://italia.edulabs.online/cart/43345614766198:1',
      '111': 'https://italia.edulabs.online/cart/43345619943542:1',
      '011': 'https://italia.edulabs.online/cart/43345616076918:1' // + Bump 2 + Bump 3
    };
    return urls[key] || urls['000'];
  };
  const checkoutUrl = getCheckoutUrl();
  // Dynamic pricing
  const bumpCount = [bumps.accoglienza, bumps.magicColor, bumps.agenda2030].filter(Boolean).length;
  const totalPrice = 19.9 + bumpCount * 7;
  const totalPriceFormatted = totalPrice.toFixed(2).replace('.', ',');
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'AddToCart', {
        content_name: 'Arte Pronta Bundle' + (bumpCount > 0 ? ` + ${bumpCount} Bump` : ''),
        content_type: 'product',
        value: totalPrice,
        currency: 'EUR'
      });
    }
  };
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-286">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(249,115,22,0.10) 0%, transparent 70%)'
    }} data-id="element-287"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(34,224,138,0.12) 0%, transparent 70%)'
    }} data-id="element-288"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-289">
        <h2 className="text-3xl sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-290">
          L'Offerta "Arte Pronta"
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(59,130,246,0.15)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-291">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-292"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-293">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-294">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          {/* Compact list on mobile — dynamic items */}
          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-295">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-296">
              <span data-id="element-297">Percorso Didattico (5 Tomi Classe 1ª-5ª)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-298">
                € 97
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-299">
              <span data-id="element-300">Registro dell'Esperto & Materiale LIM</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-301">
                € 57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-302">
              <span data-id="element-303">Manuali Tecnici di Disegno</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-304">
                € 47
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-305">
              <span data-id="element-306">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-307">
                € 49
              </span>
            </div>

            {/* Dynamic bump items */}
            {bumps.accoglienza && <div className="flex justify-between text-cta-green font-medium border-b border-cta-green/20 pb-1.5 sm:pb-3 animate-[fadeInUp_0.3s_ease-out]" data-id="element-308">
                <span data-id="element-309">✅ Kit Accoglienza</span>
                <span className="ml-2 flex-shrink-0 font-bold" data-id="element-310">+ € 7,00</span>
              </div>}
            {bumps.magicColor && <div className="flex justify-between text-cta-green font-medium border-b border-cta-green/20 pb-1.5 sm:pb-3 animate-[fadeInUp_0.3s_ease-out]" data-id="element-311">
                <span data-id="element-312">✅ Manuale "Magic Color"</span>
                <span className="ml-2 flex-shrink-0 font-bold" data-id="element-313">+ € 7,00</span>
              </div>}
            {bumps.agenda2030 && <div className="flex justify-between text-cta-green font-medium border-b border-cta-green/20 pb-1.5 sm:pb-3 animate-[fadeInUp_0.3s_ease-out]" data-id="element-314">
                <span data-id="element-315">✅ Arte & Sostenibilità</span>
                <span className="ml-2 flex-shrink-0 font-bold" data-id="element-316">+ € 7,00</span>
              </div>}

            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-317">
              <span data-id="element-318">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-319">
                € {250 + bumpCount * 19}
              </span>
            </div>
          </div>

          {/* Price reveal — DYNAMIC */}
          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/5 to-transparent border border-white/10 py-6 sm:py-10 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-320">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-321"></div>

            {/* Original price + discount badge */}
            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-4" data-id="element-322">
              <span className="text-text-sec line-through text-base sm:text-2xl font-medium" data-id="element-323">
                € {(250 + bumpCount * 19).toFixed(2).replace('.', ',')}
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-324">
                {Math.round(100 - totalPrice / (250 + bumpCount * 19) * 100)}%
                OFF
              </span>
            </div>

            {/* Big price */}
            <div className="text-5xl sm:text-8xl tracking-tighter transition-all leading-none font-[800] text-[#FFFFFF]" data-id="element-325">
              € {totalPriceFormatted}
            </div>

            {bumpCount > 0 && <div className="text-cta-green text-xs sm:text-base font-bold mt-2 sm:mt-3 animate-[fadeIn_0.3s_ease-out]" data-id="element-326">
                🎉 Risparmi € {(bumpCount * 12).toFixed(2).replace('.', ',')}{' '}
                sui bonus aggiunti!
              </div>}

            <div className="text-text-sec text-xs sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-327">
              <span data-id="element-328">💳 Pagamento unico</span>
              <span data-id="element-329">•</span>
              <span data-id="element-330">⚡ Accesso immediato</span>
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse-composited mx-auto mb-3 sm:mb-6" data-id="element-331">
            ⏰ Prezzo speciale di lancio — salirà a breve
          </span>

          {/* CTA Button — Top */}
          <a href={checkoutUrl} onClick={firePixel} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-[17px] sm:text-2xl py-5 sm:py-6 rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_4px_12px_rgba(0,0,0,0.25)] mb-6 leading-tight" data-id="element-332">
            <span className="hidden sm:inline" data-id="element-333">
              🚀 SÌ! VOGLIO IL KIT COMPLETO — € {totalPriceFormatted}
            </span>
            <span className="sm:hidden text-[18px]" data-id="element-334">
              🚀 VOGLIO IL KIT — € {totalPriceFormatted}
            </span>
          </a>

          {/* Order Bumps Section */}
          <div className="flex flex-col gap-3 sm:gap-4 mb-6 sm:mb-8 w-full" data-id="element-335">
            <p className="text-center text-text-sec text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-1" data-id="element-336">
              ⚡ Aggiungi al tuo ordine e risparmia:
            </p>

            {/* Bump 1: Kit Accoglienza */}
            <label className={`relative flex flex-col items-center p-4 sm:p-5 rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${bumps.accoglienza ? 'bg-orange-500/10 border-orange-500' : 'bg-bg-alt border-orange-500/40 hover:border-orange-500/70'} ${flashKey === 'accoglienza' ? 'animate-[bumpFlash_0.6s_ease-out]' : ''}`} data-id="element-337">
              <span className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] sm:text-xs font-black uppercase tracking-wider px-4 py-1 sm:py-1.5 rounded-full mb-3" data-id="element-338">
                ⭐ ALTAMENTE RACCOMANDATO
              </span>
              <div className="flex items-start gap-3 w-full" data-id="element-339">
                <div className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mt-1 rounded border-2 flex-shrink-0 transition-colors ${bumps.accoglienza ? 'bg-orange-500 border-orange-500' : 'bg-transparent border-orange-500/50'}`} data-id="element-340">
                  <input type="checkbox" className="opacity-0 absolute inset-0 cursor-pointer" checked={bumps.accoglienza} onChange={e => handleBumpChange('accoglienza', e.target.checked)} data-id="element-341" />
                  {bumps.accoglienza && <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-342">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-343" />
                    </svg>}
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/4bULZ8iWc2zepCmzLMCaRu/heylloyd-image-1777310964097.png" alt="Kit Accoglienza" className="w-[56px] h-[56px] sm:w-[72px] sm:h-[72px] rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-344" />
                <div className="min-w-0 flex-1" data-id="element-345">
                  <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-346">
                    Kit Accoglienza 🎒
                  </p>
                  <p className="text-orange-500 font-black text-sm sm:text-lg mt-0.5" data-id="element-347">
                    + € 7,00{' '}
                    <span className="text-text-sec font-normal text-xs line-through ml-1" data-id="element-348">
                      € 19,00
                    </span>
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-1" data-id="element-349">
                    30 pagine con 10 attività "Apri e Stampa" per decorare
                    l'aula e gestire il primo giorno senza stress.
                  </p>
                </div>
              </div>
            </label>

            {/* Bump 2: Magic Color */}
            <label className={`relative flex flex-col items-center p-4 sm:p-5 rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${bumps.magicColor ? 'bg-orange-500/10 border-orange-500' : 'bg-bg-alt border-orange-500/40 hover:border-orange-500/70'} ${flashKey === 'magicColor' ? 'animate-[bumpFlash_0.6s_ease-out]' : ''}`} data-id="element-350">
              <span className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] sm:text-xs font-black uppercase tracking-wider px-4 py-1 sm:py-1.5 rounded-full mb-3" data-id="element-351">
                ⭐ ALTAMENTE RACCOMANDATO
              </span>
              <div className="flex items-start gap-3 w-full" data-id="element-352">
                <div className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mt-1 rounded border-2 flex-shrink-0 transition-colors ${bumps.magicColor ? 'bg-orange-500 border-orange-500' : 'bg-transparent border-orange-500/50'}`} data-id="element-353">
                  <input type="checkbox" className="opacity-0 absolute inset-0 cursor-pointer" checked={bumps.magicColor} onChange={e => handleBumpChange('magicColor', e.target.checked)} data-id="element-354" />
                  {bumps.magicColor && <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-355">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-356" />
                    </svg>}
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/r68EvcBZh2YTdygAFUMv9a/heylloyd-image-1777311240464.png" alt="Magic Color" className="w-[56px] h-[56px] sm:w-[72px] sm:h-[72px] rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-357" />
                <div className="min-w-0 flex-1" data-id="element-358">
                  <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-359">
                    Manuale "Magic Color" 🎨
                  </p>
                  <p className="text-orange-500 font-black text-sm sm:text-lg mt-0.5" data-id="element-360">
                    + € 7,00{' '}
                    <span className="text-text-sec font-normal text-xs line-through ml-1" data-id="element-361">
                      € 19,00
                    </span>
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-1" data-id="element-362">
                    Trucchi di sfumatura, gradienti e miscele con pennarelli.
                    Trasforma disegni mediocri in opere da mostra.
                  </p>
                </div>
              </div>
            </label>

            {/* Bump 3: Agenda 2030 */}
            <label className={`relative flex flex-col items-center p-4 sm:p-5 rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${bumps.agenda2030 ? 'bg-orange-500/10 border-orange-500' : 'bg-bg-alt border-orange-500/40 hover:border-orange-500/70'} ${flashKey === 'agenda2030' ? 'animate-[bumpFlash_0.6s_ease-out]' : ''}`} data-id="element-363">
              <span className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] sm:text-xs font-black uppercase tracking-wider px-4 py-1 sm:py-1.5 rounded-full mb-3" data-id="element-364">
                ⭐ ALTAMENTE RACCOMANDATO
              </span>
              <div className="flex items-start gap-3 w-full" data-id="element-365">
                <div className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mt-1 rounded border-2 flex-shrink-0 transition-colors ${bumps.agenda2030 ? 'bg-orange-500 border-orange-500' : 'bg-transparent border-orange-500/50'}`} data-id="element-366">
                  <input type="checkbox" className="opacity-0 absolute inset-0 cursor-pointer" checked={bumps.agenda2030} onChange={e => handleBumpChange('agenda2030', e.target.checked)} data-id="element-367" />
                  {bumps.agenda2030 && <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-368">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-369" />
                    </svg>}
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/vLxodoU4wJjRmesLG8jt4K/heylloyd-image-1777311472355.png" alt="Arte & Sostenibilità — Agenda 2030" className="w-[56px] h-[56px] sm:w-[72px] sm:h-[72px] rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-370" />
                <div className="min-w-0 flex-1" data-id="element-371">
                  <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-372">
                    Arte & Sostenibilità 🌍
                  </p>
                  <p className="text-orange-500 font-black text-sm sm:text-lg mt-0.5" data-id="element-373">
                    + € 7,00{' '}
                    <span className="text-text-sec font-normal text-xs line-through ml-1" data-id="element-374">
                      € 19,00
                    </span>
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-1" data-id="element-375">
                    12 laboratori di Educazione Civica sul riciclo e Agenda
                    2030. Include griglia di valutazione ufficiale.
                  </p>
                </div>
              </div>
            </label>
          </div>

          {/* CTA Button — Bottom (duplicate for visibility) */}
          <a href={checkoutUrl} onClick={firePixel} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black sm:text-2xl py-5 sm:py-6 rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_4px_12px_rgba(0,0,0,0.25)] mb-6 text-[18px] leading-tight" data-id="element-376">
            🚀 ACQUISTA ORA — € {totalPriceFormatted}
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-377">
            <span data-id="element-378">⚡ Accesso Immediato</span>
            <span data-id="element-379">•</span>
            <span data-id="element-380">💳 Un solo Pagamento</span>
            <span data-id="element-381">•</span>
            <span data-id="element-382">🛡️ Garanzia 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}